import Link from 'next/link';

export default function NoStorePage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-bone">
      <div className="max-w-md rounded-md border border-forest/20 bg-white p-8 text-center">
        <h1 className="text-lg font-semibold text-forest">You don&apos;t have a store yet</h1>
        <p className="mt-2 text-sm text-forest/70">
          The seller dashboard is for users with a provisioned Alqove store.
          If you believe this is a mistake, contact support.
        </p>
        <Link
          href="/"
          className="mt-4 inline-block rounded border border-forest/20 px-4 py-2 text-sm font-medium text-forest hover:bg-forest/5"
        >
          Back to marketplace
        </Link>
      </div>
    </div>
  );
}
